var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ai-fab",on:{"click":_vm.togglePanel}},[_c('img',{staticClass:"ai-icon",attrs:{"src":require("@/assets/icons/ai.svg"),"alt":"AI"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }